document.querySelectorAll('.faq-question').forEach(function(button) {
  button.addEventListener('click', function() {
    var isExpanded = button.getAttribute('aria-expanded') === 'true';
    var item = button.closest('.faq-item');
    var answer = item ? item.querySelector('.faq-answer') : null;
    if (!answer) return;
    button.setAttribute('aria-expanded', !isExpanded);
    if (!isExpanded) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    } else {
      answer.style.maxHeight = null;
    }
  });
});
